import { SxProps } from '@mui/material';
import { SimpleTreeView } from '@mui/x-tree-view';
import React from 'react';
import { renderTreeNodes } from './renderTreeNodes';
import { FolderTreeNode, TreeLabelBaseProperties } from './types';

export const FilterTree: React.FC<{
  nodes: FolderTreeNode[];
  selectedItems: string;
  onSelectedItemsChange: (itemId: string) => void;
  expandedItems: string[];
  onExpandedItemsChange: (itemIds: string[]) => void;
  renderLabel: (properties: TreeLabelBaseProperties) => React.ReactNode;
  sx?: SxProps;
}> = ({ nodes, selectedItems, onSelectedItemsChange, expandedItems, onExpandedItemsChange, renderLabel, sx }) => {
  return (
    <SimpleTreeView
      selectedItems={selectedItems}
      onSelectedItemsChange={(_event, itemId) => itemId && onSelectedItemsChange(itemId)}
      expandedItems={expandedItems}
      onExpandedItemsChange={(_event, itemIds) => onExpandedItemsChange(itemIds)}
      sx={sx}
    >
      {nodes.length > 0 && renderTreeNodes({ nodes, level: 0, renderLabel })}
    </SimpleTreeView>
  );
};
